// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_h0-a";
export var fulfillmentFormRail = "_h0-9";
export var headerTitleRow = "_h0-c";
export var orderDetailsWrapper = "_h0-7";
export var orderLinkTrigger = "_h0-2";
export var paymentInformationGrid = "_h0-h";
export var paymentSummaryColumn = "_h0-i";
export var shipmentContainer = "_h0-b";
export var shipmentDetailsMainPane = "_h0-8";
export var shipmentNavigationCard = "_h0-5";
export var shipmentNavigationRail = "_h0-3";
export var shipmentNavigationRailHeader = "_h0-4";
export var shipmentSummaryFact = "_h0-e";
export var shipmentSummaryGrid = "_h0-d";
export var shipmentSummaryMetadataRow = "_h0-f";
export var shipmentSummaryTags = "_h0-g";
export var shipmentWorkspace = "_h0-0";
export var shipmentWorkspaceContent = "_h0-6";
export var shipmentWorkspaceHeader = "_h0-1";